<template>
  <div class="order-regional-distribution">
    <gj-analysis-panel
        :title="'订单区域分布'"
    >
      <template #subtitle>
        <gj-select
            style="margin-left: 14px;"
            v-model="orderType"
            :options="option.orderTypeOptions"
            :clearable="false"
            @input="changeOrderType"
        ></gj-select>
        <span class="left-option-header-time">
          {{startDate}} ~ {{endDate}} {{dateShortcut | defaultShow('| ', '', '')}}
        </span>
      </template>
      <template #rightContainer>
        <OptionGroup
            :show-list= "['refresh']"
            :show-panel-btn="true"
            @refresh="refresh"
            @showPanel="showPanel"
        />
      </template>
      <template #panelBody>
        <div class="order-regional-distribution-content">
          <el-row :gutter="10">
            <el-col :span="14" v-if="!isShowPanel">
              <el-card class="box-card map-relative">
                <el-button v-show="geoPosition !== 'world'"  @click="handleEsc" class="back-to-world" icon="el-icon-back"></el-button>
<!--                <ve-amap height="400px"-->
<!--                        :series="mapChartData.series"-->
<!--                         :settings="mapChartData.settings"-->
<!--                        :tooltip="mapChartData.tooltip"-->
<!--                        :after-set-option="afterSetOption"-->
<!--                        @beforeRegisterMap="beforeRegisterMap">-->
<!--                  -->
<!--                </ve-amap>-->
                <Chart height="400px" :option="mapChartData"/>
              </el-card>
            </el-col>
            <el-col :span="10" v-if="!isShowPanel">
              <el-card class="box-card">
                <gj-table
                          ref="gjTable"
                          :index="false"
                          show-overflow
                          highlight-hover-row
                          :adapt-height="false"
                          :height="400"
                          :loading="loading"
                          :data="mapTableData"
                          :columns="columns"
                >
                  <template v-slot:rank="{row, index}">
                    {{index + 1}}
                  </template>
                  <template v-slot:pre="{ row }">
                    {{ row.pre ? row.pre: 0 }}%
                  </template>
                </gj-table>
              </el-card>
            </el-col>
            <el-col :span="24" v-if="isShowPanel">
              <img src="../../../../../assets/images/kanbanDescription.png" class="kanbanImg"/>
            </el-col>
          </el-row>
        </div>
      </template>
    </gj-analysis-panel>
  </div>
</template>

<script>

import OptionGroup from "@/views/components/option-panel-group/option-group"
import { getOrderAreaDistributed } from "@/api/statistics";
import {orderTypeOptions} from "@/utils/options";
import {convertToFullDate, dateShortcut} from "@/utils/date.util";


import Chart from "@/views/components/chart/chart"
export default {
  name: "order-regional-distribution",
  components: { OptionGroup, Chart },
  inject: ['getPageParams'],
  data(){
    return{
      useCache: false,
      isShowPanel: false,
      loading: false,
      orderRegionalDistributionOption: {},
      columns: [
        {id: 'rank', header: '排名', field: 'slot:rank', minWidth: '60px', align: 'center'},
        {id: 'area', header: '地区', field: 'area', minWidth: '60px',},
        {id: 'orders', header: '订单量', field: 'orders', minWidth: '60px', align: 'center'},
        {id: 'pre', header: '订单占比', field: 'slot:pre', minWidth: '120px', align: 'center'},
      ],
      option: {
        orderTypeOptions: orderTypeOptions
      },
      orderType: 'ALL',
      mapData: [],
      echartsInstance: null,
      geoOrigin: '',
      geoPosition: 'world',
      prefixUrl: 'https://s3.gerpgo.com/cloud/web',
      areaJsonMap: {
        'United States': 'USA'
      },
      mapNameList: []
    }
  },
  computed: {
     startDate() {
      let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[0], dateFormat) : null;
    },
    endDate() {
       let dateFormat;
      if (this.filter.date.key === 0) {
        dateFormat = 'yyyy-MM-dd'
      } else {
        dateFormat = 'yyyy-MM'
      }
      return this.filter.date.value ? convertToFullDate(this.filter.date.value[1], dateFormat) : null;
    },
    dateShortcut() {
      return dateShortcut(this.filter.date.key === 0?this.filter.date.value:'');
    },
    filter () {
      return this.getPageParams()
    },
    mapTableData ({ mapData = [] }) {
      return mapData.slice(0, 10)
    },
    mapChartData ({ mapData = [] }) {
      const numbers = mapData.map(({ orders = 0 }) => orders)
      const maxNum = Math.max.apply(null, numbers)
      return {
        tooltip: {
          trigger: 'item',
          formatter: function(v) {
            const tpl = []
            tpl.push(v.name + '：' + v.value[2])
            return tpl.join('')
          }
        },
        geo: {
          map: 'world',
          roam: true,
          zoom: 3,
          center: [-99.733333, 32.450000],
          resizeEnable: true,
          scaleLimit: {          // 可选：限制用户的缩放范围
            min: 1,
            max: 8
          },
          emphasis: {
            label: {
              show: false
            },
            itemStyle: {
              areaColor: '#eee'
            }
          },
        },
        series : [{
            name: 'order',
            type: 'effectScatter',   
            coordinateSystem: 'geo',
            geoIndex: 0,               
            symbol: 'circle',
            symbolSize: (value, params) => {
              return (value[2] / maxNum) * 50
            },
          encode: {
            value: 2
          },
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          label: {
            formatter: '{b}',
            position: 'right',
            show: false
          },
          itemStyle: {
            color: '#4A8EFC',
            shadowBlur: 10,
            shadowColor: '#333'
          },
          zlevel: 1,
          data: mapData.filter(({areas = '', longitude = '', latitude = ''}) => longitude && latitude).map(({area = '', orders = 0, longitude = '', latitude = '' }) => ({name: area, value: [parseFloat(longitude), parseFloat(latitude), orders]})),
          }
        ]
      }
    }
  },
  created () {
    this.getOrderAreaDistributed()
  },
  methods:{
    refresh(){
      this.getOrderAreaDistributed()
    },
    /**
     * 获取订单区域分布
     */
    getOrderAreaDistributed () {
      const params = {
        ...this.filter,
        orderType: this.orderType
      }
      getOrderAreaDistributed(params).then(res => {
        this.mapData = res
        this.mapData.sort((a, b) => b.pre - a.pre)
      })
    },
    /**
     *  显示看板
     */
    showPanel(value){
      this.isShowPanel = value;
    },
    /**
     *  切换订单选择
     *  type 0 全部订单 1 促销订单
     */
    changeOrderType(type){
      this.getOrderAreaDistributed()
    },
    /**
     * esc事件
     */
    handleEsc () {
      this.geoPosition = 'world'
    },
    beforeRegisterMap (params) {
      console.warn(params)
    },
    /**
     * 获取echarts实例
     * @param instance
     */
    afterSetOption (instance) {
      this.echartsInstance = instance
    }
  }
}
</script>

<style scoped>
@import "../common/index.scss";

.map-relative {
  position: relative;
}

.back-to-world {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 9999;
}

.order-regional-distribution{
  padding-top: 10px;
}
/deep/ .panelDetailBtn{
  margin-left: 10px;
}
.kanbanImg{
  width: 100%;
  height: 100%;
  max-height: 300px;
}

.left-option-header-time {
  display: inline-block;
  margin-left: 14px;
  font-size: 12px;
  color: #888;
  font-weight: 500;
}



</style>
